import React, { useEffect, useState } from "react";
import { OrganApi } from "../../../../../../api/OrganApi";
import { executePromise } from "../../../../../../util/sliceUtil";

/**
 * 교사용AI 기관유형 권한부여(기관 단위).
 * 레퍼런스(260730) "기관별 org_type 권한부여" 의도대로, 본사가 기관마다
 * 학교용(방과후)/센터용(치료·훈련센터)을 지정한다. 소속관리자 교사 대시보드의
 * 메뉴/기능(반·출석 vs 상담노트)이 이 값으로 분기된다.
 */
const OPTIONS: { value: string; label: string }[] = [
  { value: "SCHOOL_AFTERSCHOOL", label: "학교용 (방과후 프로그램)" },
  { value: "TRAINING_CENTER", label: "센터용 (치료·훈련센터)" },
];

interface TeacherConfigResponse {
  orgType?: string;
  configured?: boolean;
}

export function OrganTeacherTypeField({ organIdx }: { organIdx: number }) {
  const [orgType, setOrgType] = useState<string>("SCHOOL_AFTERSCHOOL");
  const [configured, setConfigured] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    let alive = true;
    setLoaded(false);
    executePromise<TeacherConfigResponse>(OrganApi.getOrganTeacherConfig(organIdx))
      .then((res) => {
        if (!alive) return;
        const data = res as unknown as TeacherConfigResponse;
        setOrgType(data?.orgType ?? "SCHOOL_AFTERSCHOOL");
        setConfigured(!!data?.configured);
        setLoaded(true);
      })
      .catch(() => {
        if (alive) setLoaded(true);
      });
    return () => {
      alive = false;
    };
  }, [organIdx]);

  const save = () => {
    setSaving(true);
    executePromise(OrganApi.updateOrganTeacherConfig(organIdx, orgType))
      .then(() => {
        setConfigured(true);
        alert("교사용AI 유형이 저장되었습니다.");
      })
      .catch(() => alert("저장에 실패했습니다."))
      .finally(() => setSaving(false));
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
        padding: "14px 16px",
        marginTop: 12,
        border: "1px solid #E5E7EB",
        borderRadius: 8,
        background: "#F9FAFB",
      }}
    >
      <strong style={{ fontSize: 13, color: "#1F4E78", minWidth: 100 }}>교사용AI 유형</strong>
      <select
        value={orgType}
        disabled={!loaded || saving}
        onChange={(e) => setOrgType(e.target.value)}
        style={{ padding: "8px 10px", borderRadius: 6, border: "1px solid #D1D5DB", fontSize: 13 }}
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={save}
        disabled={!loaded || saving}
        style={{
          padding: "8px 16px",
          borderRadius: 6,
          border: "none",
          background: "#1F4E78",
          color: "#fff",
          fontSize: 13,
          fontWeight: 700,
          cursor: saving ? "not-allowed" : "pointer",
          opacity: saving ? 0.6 : 1,
        }}
      >
        {saving ? "저장 중…" : "저장"}
      </button>
      {loaded && !configured && (
        <span style={{ fontSize: 12, color: "#9CA3AF" }}>미설정 — 기관 유형 기반 기본 추정값입니다.</span>
      )}
    </div>
  );
}
